import {styled} from "@mui/system";
import {Box} from "@mui/material";

const MainJournalSliderCard = styled(Box)(({theme}) => ({
    '& .swiper-wrapper': {
        width: '100% !important',
    },
    '& .swiper': {
        marginTop: theme.spacing(1),
        height: '95%',
    },
    '& .swiper-slide': {
        height: 'auto',
    },
    ' .swiper-pagination-bullet': {
        background: 'none !important',
        backgroundImage: `${theme.palette.custom?.backgroundPaginationBulletSlider} !important`,
        boxShadow: '0 1px 0 rgba(153,153,153,0.5) !important',
        border: `1px solid ${theme.palette.custom?.borderPaginationBulletSlider} !important`,
        position: 'relative !important',
        opacity: '.7 !important',
        '&.swiper-pagination-bullet-active': {
            border: 'none',
            transform: 'scale(1.4)',
            opacity: 1,
            position: 'relative',
            zIndex: 1,
            '&::after': {
                content: '""',
                position: 'absolute',
                width: '50%',
                height: '50%',
                backgroundColor: theme.palette.custom?.brown,
                borderRadius: '50%',
                left: '25%',
                top: '25%',
            }
        },
    },
    ' .swiper-button-next': {
        fill: theme.palette.custom?.brown,
        backgroundImage: theme.palette.custom?.backgroundArrowButtonSlider,
        boxShadow: '0 2px 0 rgba(153, 153, 153, 0.25)',
        left: 'auto',
        right: '3px',
        width: '1rem',
        height: '1rem',
        position: 'absolute',
        bottom: 'auto',
        margin: 0,
        cursor: 'pointer',
        alignItems: 'center',
        background: '#ccc',
        border: 'none',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        opacity: '.7',
        zIndex: '1',
        '&::after': {
            fontWeight: 900,
            content: '"\\27A4"',
            color: theme.palette.custom?.brown,
            fontSize: '.6rem',
            verticalAlign: 'middle',
            display: 'inline-block',
        }
    },
    ' .swiper-button-prev': {
        fill: theme.palette.custom?.brown,
        backgroundImage: 'theme.palette.custom?.backgroundArrowButtonSlider',
        boxShadow: '0 2px 0 rgba(153, 153, 153, 0.25)',
        left: '3px',
        right: 'auto',
        width: '1rem',
        height: '1rem',
        position: 'absolute',
        bottom: 'auto',
        cursor: 'pointer',
        alignItems: 'center',
        margin: 0,
        background: '#ccc',
        border: 'none',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        opacity: '.7',
        zIndex: '1',
        '&::after': {
            fontWeight: 900,
            content: '"\\27A4"',
            color: theme.palette.custom?.brown,
            fontSize: '.6rem',
            verticalAlign: 'middle',
            transform: 'rotate(-180deg)',
            display: 'inline-block',
        }
    },
}));

export default MainJournalSliderCard;
